import { ADMIN_TYPE_ROLES, ADMIN_TYPE_ROLES_ONLY } from '../constants/common';
import { SystemRoles } from '../enums/common';

const transformUserName = ({ firstName, middleName, lastName }: any) => {
  let str = '';
  if (firstName) {
    str += firstName;
  }

  if (middleName) {
    str += ' ' + middleName;
  }

  if (lastName) {
    str += ' ' + lastName;
  }
  return str || '-';
};

const capitalizeFirstLetter = (str: string) => {
  try {
    if (typeof str !== 'string') {
      return '';
    }
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  } catch (err) {
    console.error(err);
    return '';
  }
};

const formatName = (str: string) => {
  return str
    .trim()
    .split(/\s+/)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

const downloadFileFromBlob = (blob: Blob, filename: string) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  a.remove();
};

export {
  transformUserName,
  capitalizeFirstLetter,
  downloadFileFromBlob,
  formatName,
};

export function isAdminTypeRole(user: any): boolean {
  return user?.userPanelRoles?.some((item: any) =>
    ADMIN_TYPE_ROLES.includes(item?.role?.name?.toUpperCase()),
  );
}

export function isAdminOnly(user: any): boolean {
  return user?.userPanelRoles?.some((item: any) =>
    ADMIN_TYPE_ROLES_ONLY.includes(item?.role?.name?.toUpperCase()),
  );
}

export function isTravelFinance(user: any): boolean {
  return user?.userPanelRoles?.some((item: any) =>
    SystemRoles.TRAVEL_FINANCE?.includes(item?.role?.name?.toUpperCase()),
  );
}

export function isTravelAdmin(user: any): boolean {
  return user?.userPanelRoles?.some((item: any) =>
    SystemRoles.TRAVEL_ADMIN.includes(item?.role?.name?.toUpperCase()),
  );
}

// Returns true only when user has TRAVEL_FINANCE but NOT TRAVEL_ADMIN
// (used to hide PUSH — if user has either role, PUSH should be visible)
export function shouldHideTravelPush(user: any): boolean {
  return !isTravelFinance(user) && !isTravelAdmin(user);
}

export function isContractFinance(user: any): boolean {
  return user?.userPanelRoles?.some((item: any) =>
    SystemRoles.CONTRACT_FINANCE.includes(item?.role?.name?.toUpperCase()),
  );
}

export function isContractAdmin(user: any): boolean {
  return user?.userPanelRoles?.some((item: any) =>
    SystemRoles.CONTRACT_ADMIN.includes(item?.role?.name?.toUpperCase()),
  );
}

// Hide PUSH when user has neither CONTRACT_ADMIN nor CONTRACT_FINANCE
export function shouldHideContractPush(user: any): boolean {
  return !isContractFinance(user) && !isContractAdmin(user);
}

export function isSalesOrderFinance(user: any): boolean {
  return user?.userPanelRoles?.some((item: any) =>
    SystemRoles.SALES_ORDER_FINANCE.includes(item?.role?.name?.toUpperCase()),
  );
}

export function isSalesOrderAdmin(user: any): boolean {
  return user?.userPanelRoles?.some((item: any) =>
    SystemRoles.SALES_ORDER_ADMIN.includes(item?.role?.name?.toUpperCase()),
  );
}

export function isTravelDesk(user: any): boolean {
  return user?.userPanelRoles?.some((item: any) =>
    SystemRoles.TRAVEL_DESK.includes(item?.role?.name?.toUpperCase()),
  );
}
